import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ProfileSetup from "./pages/ProfileSetup";
import Profile from "./pages/Profile";
import ProfileView from "./pages/ProfileView";
import Discovery from "./pages/Discovery";
import Matches from "./pages/Matches";
import Chat from "./pages/Chat";
import ChatList from "./pages/ChatList";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { UserProfileModalProvider } from "./context/UserProfileModalContext";
import LoadingAnimation from "./components/LoadingAnimation";
import BuiltBySlashEasyFloating from "./components/BuiltBySlashEasyFloating";

// Protected route wrapper
const ProtectedRoute = ({ children, requireProfile = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingAnimation isVisible={true} />;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (requireProfile && !user.isProfileComplete) {
    return <Navigate to="/profile-setup" />;
  }

  return children;
};

function AppRoutes() {
  const { user } = useAuth();

  return (
    <Routes>
      <Route
        path="/login"
        element={user ? <Navigate to="/discovery" /> : <Login />}
      />
      <Route
        path="/forgot-password"
        element={user ? <Navigate to="/discovery" /> : <ForgotPassword />}
      />
      <Route
        path="/reset-password"
        element={user ? <Navigate to="/discovery" /> : <ResetPassword />}
      />
      <Route
        path="/signup"
        element={user ? <Navigate to="/discovery" /> : <Signup />}
      />
      <Route
        path="/profile-setup"
        element={
          <ProtectedRoute>
            <ProfileSetup />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile/:userId"
        element={
          <ProtectedRoute requireProfile={true}>
            <ProfileView />
          </ProtectedRoute>
        }
      />
      <Route
        path="/discovery"
        element={
          <ProtectedRoute requireProfile={true}>
            <Discovery />
          </ProtectedRoute>
        }
      />
      <Route
        path="/matches"
        element={
          <ProtectedRoute requireProfile={true}>
            <Matches />
          </ProtectedRoute>
        }
      />
      <Route
        path="/chats"
        element={
          <ProtectedRoute requireProfile={true}>
            <ChatList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/chat/:matchId"
        element={
          <ProtectedRoute requireProfile={true}>
            <Chat />
          </ProtectedRoute>
        }
      />
      <Route
        path="/"
        element={user ? <Navigate to="/discovery" /> : <Landing />}
      />
    </Routes>
  );
}

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <UserProfileModalProvider>
          <AppRoutes />
          <BuiltBySlashEasyFloating />
        </UserProfileModalProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
